import Button from '@carvana/ds-button';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { isCarvanaNativeApp, isAndroidNativeWebview } from '|/helpers/is-native-app';
import { MobileWebviewEvents } from '|/helpers/mobile-webview-events/mobile-webview-events';
import sendNativeEvent from '|/helpers/send-native-event';
import useAnalyticsContext from '|/hooks/use-analytics-context';
import styles from './support-contact.module.css';

interface SupportContactProps {
  onClick: () => void;
  onClose?: () => void;
}

const SupportContact: React.FC<SupportContactProps> = ({ onClick, onClose }) => {
  const { trackEvent } = useAnalyticsContext();
  const location = useLocation();

  const handleClick = () => {
    trackEvent('pp_header_support_contact_clicked');
    if (isCarvanaNativeApp()) {
      const eventName = isAndroidNativeWebview()
        ? MobileWebviewEvents.OPEN_SEBASTIAN
        : MobileWebviewEvents.OPEN_SUPPORT;

      onClose?.();
      sendNativeEvent({
        event: eventName,
        payload: { currentStep: location.pathname },
        source: 'purchase'
      });

      return;
    }
    onClick();
  };

  return (
    <Button
      variant="primary"
      size="xs"
      onClick={handleClick}
      className={styles.supportButton}
      data-analytics-id="pp_header_support_contact"
    >
      <span className={styles.supportText}>Support & Contact</span>
    </Button>
  );
};

export default SupportContact;
